import API from '@/services/endpoint'
import { FETCH_LOCATIONS_LIST } from "../../mutation-types";

/**
 * API Get Request to fetch the location list
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @return {object[]} A array of locations
 */
export async function fetchLocations({commit, state}) {
  const { url } = state;
  let responseObj = await API.get(url);
  let { data: { message: { locations } } } = responseObj;
  commit(FETCH_LOCATIONS_LIST, locations)
}
